var wi = Object.defineProperty, ki = Object.defineProperties;
var Ai = Object.getOwnPropertyDescriptors;
var Lr = Object.getOwnPropertySymbols;
var Pi = Object.prototype.hasOwnProperty, Di = Object.prototype.propertyIsEnumerable;
var Sr = (t, r, c) => r in t ? wi(t, r, { enumerable: !0, configurable: !0, writable: !0, value: c }) : t[r] = c, e = (t, r) => {
  for (var c in r || (r = {}))
    Pi.call(r, c) && Sr(t, c, r[c]);
  if (Lr)
    for (var c of Lr(r))
      Di.call(r, c) && Sr(t, c, r[c]);
  return t;
}, s = (t, r) => ki(t, Ai(r));
import { LAYOUT_NODE_SHARED_CONTENT as xr, CONTENT_NODE_NAVIGATION as Ur, CONTENT_NODE_LIST as Rr, CONTENT_NODE_BUTTON as Fr, CONTENT_NODE_FORM as Hr, CONTENT_NODE_QUOTE as Mr, CONTENT_NODE_TABLE as D, CONTENT_NODE_CARD as Br, CONTENT_NODE_SEPARATOR as zr, CONTENT_NODE_SPACER as Wr, CONTENT_NODE_PANEL as $r, CONTENT_NODE_ACCORDION as Gr, CONTENT_NODE_VIDEO as qr, CONTENT_NODE_CODE as Yr, CONTENT_NODE_SLIDER as Vr, CONTENT_NODE_GALLERY as Qr, CONTENT_NODE_IMAGE as I, CONTENT_NODE_TEXT as L, CONTENT_NODE_HEADING as S, LAYOUT_NODE_FULL_WIDTH_COLUMN as jr, LAYOUT_NODE_RIGHT_SIDEBAR as Xr, LAYOUT_NODE_LEFT_SIDEBAR as Kr, LAYOUT_NODE_QUADRUPLE_COLUMN as Jr, LAYOUT_NODE_TRIPLE_COLUMN as Zr, LAYOUT_NODE_DOUBLE_COLUMN as dr, LAYOUT_NODE_SINGLE_COLUMN as ti, BASE_COLUMN as E, getBaseLayoutNode as w, getBaseContentNode as vr } from "@apptegy/page-builder";
const ri = "ts-one-column", ii = "ts-two-column", ei = "ts-three-column", si = "ts-four-column", v = "ts-full-width", ai = "ts-left-sidebar", ci = "ts-right-sidebar", O = "pb-shared-content-block", oi = "ts-heading", pi = "ts-text", ni = "ts-video", li = "ts-embed", gi = "ts-slider", mi = "ts-spacer", ui = "ts-image", fi = "ts-gallery", _i = "ts-divider", hi = "ts-accordion", Li = "ts-table", Ti = "ts-table-v2", Ci = "ts-button", Ni = "ts-card", bi = "ts-quote", Ii = "ts-form", Oi = "ts-list", yi = "ts-navigation", Mi = (t, r) => {
  var n;
  const c = r || {};
  return [
    {
      id: t.id,
      name: t.name,
      component: t.type,
      properties: Ei(t),
      config: (n = t.nodes) == null ? void 0 : n.map((l) => [k(l, c)])
    }
  ];
}, k = (t, r) => {
  var c, n, l, h, m, u, f;
  switch (t.type) {
    case ti:
      return s(e({}, N(t, r)), {
        name: "One Column",
        component: ri
      });
    case dr:
      return s(e({}, N(t, r)), {
        name: "2 Columns",
        component: ii
      });
    case Zr:
      return s(e({}, N(t, r)), {
        name: "3 Columns",
        component: ei
      });
    case Jr:
      return s(e({}, N(t, r)), {
        name: "4 Columns",
        component: si
      });
    case Kr:
      return s(e({}, N(t, r)), {
        name: "Left Sidebar",
        component: ai
      });
    case Xr:
      return s(e({}, N(t, r)), {
        name: "Right Sidebar",
        component: ci
      });
    case jr:
      return s(e({}, N(t, r)), {
        name: "Full Width",
        component: v
      });
    case S:
      return {
        id: t.id,
        name: "Headline",
        component: oi,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: _(t),
        hasForm: !1
      };
    case L:
      return {
        id: t.id,
        name: "Text",
        component: pi,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: _(t),
        hasForm: !1
      };
    case I: {
      const a = {
        image: {
          // CONTENT
          url: (t == null ? void 0 : t.assetUrl) || ((c = t == null ? void 0 : t.content) == null ? void 0 : c.assetUrl) || ((n = r[t.content.assetId]) == null ? void 0 : n.url) || "",
          asset_id: t.content.assetId,
          alt_text: t.content.altText,
          caption: t.content.caption,
          link_url: t.content.link,
          // PROPERTIES
          set_ratio: t.properties.columnPercentage / 100,
          is_resized: t.properties.isResized,
          action_on_click: t.properties.actionOnClick,
          open_link_in_new_tab: t.properties.newTab,
          image_alignment: t.properties.imageAlignment,
          caption_alignment: t.properties.captionAlignment,
          show_caption: !!t.properties.showCaption,
          display: t.properties.resizeMode,
          cropped_width: t.properties.naturalWidth,
          cropped_height: t.properties.naturalHeight,
          preferred_width: t.properties.preferredWidth,
          preferred_height: t.properties.preferredHeight,
          decorative_image: t.properties.isDecorative,
          backgroundPosition: t.properties.backgroundPosition || "center",
          tilePercentage: t.properties.tilePercentage || 100
        }
      };
      return {
        id: t.id,
        name: "Image",
        component: ui,
        config: a,
        properties: _(t),
        hasForm: !0
      };
    }
    case Qr: {
      const a = {
        blockId: t.id,
        gallery: {
          images: t.content.images.map((i) => {
            var p, C;
            return {
              url: (i == null ? void 0 : i.assetUrl) || ((p = i == null ? void 0 : i.content) == null ? void 0 : p.assetUrl) || ((C = r[i.content.assetId]) == null ? void 0 : C.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: i.content.altText,
              asset_id: i.content.assetId,
              cropped_width: i.properties.naturalWidth,
              cropped_height: i.properties.naturalHeight,
              decorative_image: i.properties.isDecorative,
              caption: i.content.caption,
              focalPointPosition: i.properties.focalPointPosition
            };
          }),
          columns: t.properties.columnsCount,
          hasLightbox: t.properties.isLightbox,
          showCaptions: t.properties.showCaptions,
          captionsAlignment: t.properties.captionsAlignment
        }
      };
      return {
        id: t.id,
        name: "Gallery",
        config: a,
        properties: _(t),
        hasForm: !0,
        component: fi
      };
    }
    case Vr: {
      const a = {
        blockId: t.id,
        slider: {
          images: t.content.images.map((i) => {
            var p, C;
            return {
              url: (i == null ? void 0 : i.assetUrl) || ((p = i == null ? void 0 : i.content) == null ? void 0 : p.assetUrl) || ((C = r[i.content.assetId]) == null ? void 0 : C.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: i.content.altText,
              asset_id: i.content.assetId,
              caption: i.content.caption,
              link_url: i.content.link,
              action_on_click: i.properties.actionOnClick,
              open_link_in_new_tab: i.properties.newTab,
              decorative_image: i.properties.isDecorative,
              focalPointPosition: i.properties.focalPointPosition,
              cropped_height: i.properties.naturalHeight,
              // NEW
              cropped_width: i.properties.naturalWidth
              // NEW
            };
          }),
          has_dots: t.properties.showDots,
          dot_position: t.properties.dotsPosition,
          has_arrows: t.properties.showArrows,
          arrow_position: t.properties.arrowsPosition,
          is_autoplay: t.properties.isAutoplay,
          transition: t.properties.transitionSpeed
        }
      };
      return {
        id: t.id,
        name: "Slider",
        config: a,
        properties: _(t),
        hasForm: !0,
        component: gi
      };
    }
    case Yr:
      return {
        id: t.id,
        name: "Code",
        component: li,
        config: {
          blockId: t.id,
          embed: t.content.html,
          hasScriptTag: t.properties.hasScriptTag
        },
        properties: _(t),
        hasForm: !1
      };
    case qr:
      return {
        id: t.id,
        name: "Video",
        component: ni,
        config: {
          blockId: t.id,
          video: {
            url: ((l = t.content) == null ? void 0 : l.embeddableUrl) || "",
            isAutoplay: !1
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Gr:
      return {
        id: t.id,
        name: "Accordion",
        component: hi,
        config: {
          blockId: t.id,
          accordion: {
            theme: t.properties.theme,
            icon_style: t.properties.iconStyle,
            allow_multiple_open_panels: t.properties.allowMultipleOpenPanels,
            items: t.nodes[0].nodes.map((a) => e({}, k(a, r)))
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case $r:
      return {
        id: t.id,
        text: t.properties.text,
        panelExpanded: t.properties.panelExpanded,
        content: t.nodes[0].nodes.map((a) => e({}, k(a, r))),
        properties: _(t)
      };
    case Wr:
      return {
        id: t.id,
        name: "Space",
        config: {
          blockId: t.id,
          spacer: {
            height: t.properties.height,
            backgroundColor: t.properties.backgroundColor || "#ffffff",
            isTransparent: t.properties.isTransparent || !1
          }
        },
        properties: _(t),
        hasForm: !0,
        component: mi
      };
    case zr:
      return {
        id: t.id,
        name: "Separator",
        component: _i,
        config: {
          blockId: t.id,
          divider: {
            thickness: t.properties.thickness,
            style: "solid",
            width: t.properties.width,
            color: { hex: t.properties.color }
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Br: {
      const { heading: a, text: i, image: p } = t.content, C = {
        blockId: t.id,
        card: {
          headline: a.content.html,
          content: i.content.html,
          image: {
            url: (p == null ? void 0 : p.assetUrl) || ((h = p == null ? void 0 : p.content) == null ? void 0 : h.assetUrl) || ((m = r[p.content.assetId]) == null ? void 0 : m.url) || "",
            alt_text: p.content.altText,
            asset_id: p.content.assetId,
            decorative_image: p.properties.isDecorative,
            focalPointPosition: p.properties.focalPointPosition,
            cropped_height: p.properties.naturalHeight,
            // NEW
            cropped_width: p.properties.naturalWidth,
            // NEW
            sizes: {}
            // Sizes are not included in the new version
          },
          design: t.properties.design,
          hasImage: t.properties.showImage,
          hasHeadline: t.properties.showHeadline,
          imageRight: t.properties.imagePosition === "right",
          wrapText: t.properties.wrapText
        }
      };
      return {
        id: t.id,
        name: "Card",
        component: Ni,
        config: C,
        properties: _(t),
        hasForm: !0
      };
    }
    case D:
      return {
        id: t.id,
        name: "Table",
        component: Ti,
        config: {
          table: {
            content: t.content.html,
            theme: t.properties.theme,
            alternatingColors: t.properties.alternatingColors
          },
          blockId: t.id
        },
        properties: _(t),
        hasForm: !0
      };
    case Mr:
      return {
        id: t.id,
        name: "Quote",
        component: bi,
        config: {
          blockId: t.id,
          quote: {
            content: t.content.quote,
            author: t.content.author,
            source: t.content.source,
            design: t.properties.design,
            color: {
              hex: t.properties.color
            }
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Hr: {
      const a = t.content.formId == null ? {} : {
        blockId: t.id,
        form: {
          form_id: t.content.formId,
          show_one_question_at_time: t.properties.showOneQuestionAtATime
        }
      };
      return {
        id: t.id,
        name: "Form",
        component: Ii,
        config: a,
        properties: _(t),
        hasForm: !0
      };
    }
    case Fr: {
      const a = {
        button: {
          // Properties
          size: t.properties.size,
          type: t.properties.type,
          theme: t.properties.theme,
          alignment: t.properties.alignment,
          pill: t.properties.pillShape,
          style: t.properties.style,
          has_icons: t.properties.hasIcons,
          // Content
          buttons: (f = (u = t.content) == null ? void 0 : u.buttons) == null ? void 0 : f.map((i) => s(e(e({
            title: i.title,
            link: i.link,
            open_link_in_new_tab: i.newTab
          }, i.icon ? { icon: i.icon } : {}), i.iconId ? { icon_id: i.iconId } : {}), {
            mailto: i.mailto
          }))
        },
        blockId: t.id
      };
      return {
        id: t.id,
        name: "Button",
        config: a,
        properties: _(t),
        hasForm: !0,
        component: Ci
      };
    }
    case Rr:
      return {
        id: t.id,
        name: "List",
        config: {
          list: {
            items: [...t.content.items],
            design: t.properties.design,
            format: t.properties.format
          },
          blockId: t.id
        },
        properties: _(t),
        hasForm: !0,
        component: Oi
      };
    case Ur:
      return {
        id: t.id,
        name: "Navigation",
        config: {
          selectedPageId: t.content.selectedPageId,
          selectedChildrenIds: t.content.selectedChildrenIds,
          design: t.properties.design,
          color: t.properties.color
        },
        hasForm: !0,
        component: yi
      };
    case xr:
      return {
        id: t.id,
        name: O,
        config: {
          id: t.id,
          name: O,
          type: O,
          sharedContentId: `${t.sharedContentId}`,
          properties: t.properties
        },
        hasForm: !0,
        component: O
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, N = (t, r) => ({
  id: t.id,
  properties: Ei(t),
  config: Si(t, r),
  hasForm: !1
}), _ = (t) => {
  var r, c;
  return {
    anchorTag: ((r = t.properties) == null ? void 0 : r.anchorTag) || "",
    customClasses: ((c = t.properties) == null ? void 0 : c.customClasses) || []
  };
}, Si = (t, r) => t.nodes ? t.nodes.map((n) => {
  var l;
  return ((l = n.nodes) == null ? void 0 : l.map((h) => k(h, r))) || n;
}) : t, Ei = (t) => {
  var r, c, n;
  return s(e({}, t.properties), {
    borderRadius: s(e({}, t.properties.borderRadius), {
      value: Number((r = t.properties.borderRadius) == null ? void 0 : r.value) || 0
    }),
    padding: s(e({}, t.properties.padding), {
      value: Number((c = t.properties.padding) == null ? void 0 : c.value) || 0
    }),
    margin: s(e({}, t.properties.margin), {
      value: Number((n = t.properties.margin) == null ? void 0 : n.value) || 0
    }),
    backgroundColor: s(e({}, t.properties.backgroundColor), {
      value: t.properties.backgroundColor.value || ""
    }),
    backgroundImage: s(e({}, t.properties.backgroundImage), {
      image: t.properties.backgroundImage.image || null
    })
  });
}, vi = (t) => {
  const { header: r, matrix: c, orientation: n, textAlign: l, bold: h } = e({ header: [] }, t), m = (f) => {
    const a = f == null ? "<p></p>" : f;
    if (l !== "center")
      return a;
    const i = /<p>/, p = /<p style=".*">/;
    return a.match(i) ? a.replace("<p>", `<p style="text-align: ${l};">`) : a.match(p) ? a.match(p)[0].includes("text-align:") ? a : a.replace('<p style="', `<p style="text-align: ${l};`) : a;
  }, u = ["<table>"];
  if (n === "horizontal")
    if (h) {
      const f = c.map((a, i) => ["<tr>", `<th scope="row">${m(r[i].value)}</th>`, ...a.map((p) => `<td>${m(p.value)}</td>`), "</tr>"].join(""));
      u.push(...f);
    } else {
      const f = c.map((a, i) => ["<tr>", `<td>${m(r[i].value)}</td>`, ...a.map((p) => `<td>${m(p.value)}</td>`), "</tr>"].join(""));
      u.push(...f);
    }
  else {
    if (r.length > 0)
      if (h) {
        const a = r.map((i) => `<th scope="col">${m(i.value)}</th>`);
        u.push("<tr>", ...a, "</tr>");
      } else {
        const a = r.map((i) => `<td>${m(i.value)}</td>`);
        u.push("<tr>", ...a, "</tr>");
      }
    const f = c.map((a) => ["<tr>", ...a.map((i) => `<td>${m(i.value)}</td>`), "</tr>"].join(""));
    u.push(...f);
  }
  return u.push("</table>"), u.join("");
};
let A;
const Bi = (t) => {
  var h, m;
  A = {};
  let r = [];
  ((h = t[0]) == null ? void 0 : h.id) === "root" ? r = t[0].config.flat() : r = t;
  const c = r.map((u) => x(u)), n = ((m = t[0]) == null ? void 0 : m.properties) || {
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    }
  };
  return {
    structure: {
      id: "root",
      name: "Root",
      type: E,
      properties: n,
      nodes: c
    },
    assets: A
  };
}, xi = ({ component: t }) => {
  const r = t === v;
  return {
    borderRadius: {
      value: 0
    },
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    },
    margin: {
      linked: !r,
      value: 10,
      top: 10,
      bottom: 10,
      left: r ? 0 : 10,
      right: r ? 0 : 10
    },
    padding: {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    customClasses: [],
    anchorTag: ""
  };
}, x = (t) => {
  var r, c, n, l, h, m, u, f, a, i, p, C, U, R, F, H, M, B, z, W, $, G, q, Y, V, Q, j, X, K, J, Z, d, tt, rt, it, et, st, at, ct, ot, pt, nt, lt, gt, mt, ut, ft, _t, ht, Tt, Ct, Nt, bt, It, Ot, yt, Et, wt, kt, At, Pt, Dt, Lt, St, vt, xt, Ut, Rt, Ft, Ht, Mt, Bt, zt, Wt, $t, Gt, qt, Yt, Vt, Qt, jt, Xt, Kt, Jt, Zt, dt, tr, rr, ir, er, sr, ar, cr, or, pr, nr, lr, gr, mr, ur, fr, _r, hr, Tr, Cr, Nr, br, Ir, Or, yr, Er, wr, kr, Ar, Pr, Dr;
  switch (t == null ? void 0 : t.component) {
    case ri:
      return s(e({}, b(t)), {
        name: "One Column",
        type: ti
      });
    case ii:
      return s(e({}, b(t)), {
        name: "Two Columns",
        type: dr
      });
    case ei:
      return s(e({}, b(t)), {
        name: "Three Columns",
        type: Zr
      });
    case si:
      return s(e({}, b(t)), {
        name: "Four Columns",
        type: Jr
      });
    case ai:
      return s(e({}, b(t)), {
        name: "Left Sidebar",
        type: Kr
      });
    case ci:
      return s(e({}, b(t)), {
        name: "Right Sidebar",
        type: Xr
      });
    case v:
      return s(e({}, b(t)), {
        name: "Full Width",
        type: jr
      });
    case oi:
      return {
        id: t.id,
        name: "Heading",
        type: S,
        content: {
          html: t.config.content
        },
        properties: g(t)
      };
    case pi:
      return {
        id: t.id,
        name: "Text",
        type: L,
        content: {
          html: t.config.content
        },
        properties: g(t)
      };
    case mi:
      return {
        id: t.id,
        name: "Spacer",
        type: Wr,
        properties: s(e({}, g(t)), {
          height: t.config.spacer.height,
          backgroundColor: t.config.spacer.backgroundColor || "#ffffff",
          isTransparent: t.config.spacer.isTransparent || !1
        })
      };
    case _i:
      return {
        id: t.id,
        name: "Separator",
        type: zr,
        properties: s(e(e({}, g(t)), t.config.divider), {
          color: (r = t.config.divider.color) == null ? void 0 : r.hex,
          style: ((c = t.config.divider) == null ? void 0 : c.style) || "solid"
        })
      };
    case li:
      return {
        id: t.id,
        name: "Code",
        type: Yr,
        content: {
          html: t.config.embed
        },
        properties: s(e({}, g(t)), {
          hasScriptTag: t.config.hasScriptTag
        })
      };
    case ni:
      return {
        id: t.id,
        name: "Video",
        type: qr,
        content: {
          rawUrl: "",
          embeddableUrl: ((n = t.config.video) == null ? void 0 : n.url) || "",
          isResized: !1,
          videoAlignment: "center",
          width: "100%"
        },
        properties: g(t)
      };
    case bi:
      return {
        id: t.id,
        name: "Quote",
        type: Mr,
        content: {
          quote: t.config.quote.content,
          author: t.config.quote.author,
          source: t.config.quote.source
        },
        properties: s(e({}, g(t)), {
          design: t.config.quote.design,
          color: t.config.quote.color.hex
        })
      };
    case ui: {
      y((h = (l = t == null ? void 0 : t.config) == null ? void 0 : l.image) == null ? void 0 : h.asset_id, (u = (m = t == null ? void 0 : t.config) == null ? void 0 : m.image) == null ? void 0 : u.url);
      const T = ((a = (f = t == null ? void 0 : t.config) == null ? void 0 : f.image) == null ? void 0 : a.show_caption) === null || ((p = (i = t == null ? void 0 : t.config) == null ? void 0 : i.image) == null ? void 0 : p.show_caption) === void 0 ? !0 : !!((U = (C = t == null ? void 0 : t.config) == null ? void 0 : C.image) != null && U.show_caption);
      return {
        id: t.id,
        name: "Image",
        type: I,
        assetUrl: ((F = (R = t == null ? void 0 : t.config) == null ? void 0 : R.image) == null ? void 0 : F.url) || "",
        content: {
          assetUrl: ((M = (H = t == null ? void 0 : t.config) == null ? void 0 : H.image) == null ? void 0 : M.url) || "",
          assetId: ((z = (B = t == null ? void 0 : t.config) == null ? void 0 : B.image) == null ? void 0 : z.asset_id) || "",
          altText: (($ = (W = t == null ? void 0 : t.config) == null ? void 0 : W.image) == null ? void 0 : $.alt_text) || "",
          caption: ((q = (G = t == null ? void 0 : t.config) == null ? void 0 : G.image) == null ? void 0 : q.caption) || "",
          link: ((V = (Y = t == null ? void 0 : t.config) == null ? void 0 : Y.image) == null ? void 0 : V.link_url) || ""
        },
        properties: s(e({}, g(t)), {
          actionOnClick: ((j = (Q = t == null ? void 0 : t.config) == null ? void 0 : Q.image) == null ? void 0 : j.action_on_click) || "no-action",
          newTab: ((K = (X = t == null ? void 0 : t.config) == null ? void 0 : X.image) == null ? void 0 : K.open_link_in_new_tab) || !1,
          imageAlignment: ((Z = (J = t == null ? void 0 : t.config) == null ? void 0 : J.image) == null ? void 0 : Z.image_alignment) || "",
          captionAlignment: ((tt = (d = t == null ? void 0 : t.config) == null ? void 0 : d.image) == null ? void 0 : tt.caption_alignment) || "",
          columnPercentage: ((it = (rt = t == null ? void 0 : t.config) == null ? void 0 : rt.image) == null ? void 0 : it.set_ratio) * 100 || 0,
          isResized: !!((st = (et = t == null ? void 0 : t.config) == null ? void 0 : et.image) != null && st.is_resized),
          resizeMode: ((ct = (at = t == null ? void 0 : t.config) == null ? void 0 : at.image) == null ? void 0 : ct.display) || "actual-size",
          showCaption: T,
          isDecorative: ((pt = (ot = t == null ? void 0 : t.config) == null ? void 0 : ot.image) == null ? void 0 : pt.decorative_image) || !1,
          naturalWidth: ((lt = (nt = t == null ? void 0 : t.config) == null ? void 0 : nt.image) == null ? void 0 : lt.cropped_width) || 0,
          naturalHeight: ((mt = (gt = t == null ? void 0 : t.config) == null ? void 0 : gt.image) == null ? void 0 : mt.cropped_height) || 0,
          preferredWidth: ((ft = (ut = t == null ? void 0 : t.config) == null ? void 0 : ut.image) == null ? void 0 : ft.preferred_width) || 0,
          preferredHeight: ((ht = (_t = t == null ? void 0 : t.config) == null ? void 0 : _t.image) == null ? void 0 : ht.preferred_height) || 0
        })
      };
    }
    case fi: {
      const T = t.config.gallery.images.map((o) => (y(o.asset_id, o.url), {
        name: "Image",
        type: I,
        assetUrl: o.url,
        content: {
          assetUrl: o.url,
          assetId: o.asset_id,
          altText: o.alt_text,
          caption: o.caption || ""
          // New
        },
        properties: s(e({}, g(t)), {
          isDecorative: o.decorative_image,
          naturalWidth: o.cropped_width,
          naturalHeight: o.cropped_height,
          focalPointPosition: o.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Gallery",
        type: Qr,
        content: {
          images: T
        },
        properties: s(e({}, g(t)), {
          columnsCount: t.config.gallery.columns,
          isLightbox: t.config.gallery.hasLightbox,
          showCaptions: t.config.gallery.showCaptions || !1,
          // New
          captionsAlignment: t.config.gallery.captionsAlignment || "center"
          // New
        })
      };
    }
    case gi: {
      const T = t.config.slider.images.map((o) => (y(o.asset_id, o.url), {
        name: "Image",
        type: I,
        assetUrl: o.url,
        content: {
          assetUrl: o.url,
          assetId: o.asset_id,
          altText: o.alt_text,
          caption: o.caption || "",
          // New
          link: o.link_url || ""
        },
        properties: s(e({}, g(t)), {
          actionOnClick: o.action_on_click,
          newTab: o.open_link_in_new_tab,
          isDecorative: o.decorative_image,
          naturalWidth: o.cropped_width || 0,
          // New
          naturalHeight: o.cropped_height || 0,
          // New
          focalPointPosition: o.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Slider",
        type: Vr,
        content: {
          images: T
        },
        properties: s(e({}, g(t)), {
          showDots: t.config.slider.has_dots,
          dotsPosition: t.config.slider.dot_position === "bottom" ? "below" : t.config.slider.dot_position,
          showArrows: t.config.slider.has_arrows,
          arrowsPosition: t.config.slider.arrow_position,
          isAutoplay: t.config.slider.is_autoplay,
          transitionSpeed: t.config.slider.transition
        })
      };
    }
    case Ci:
      return {
        id: t.id,
        name: "Button",
        type: Fr,
        content: {
          buttons: ((Nt = (Ct = (Tt = t.config) == null ? void 0 : Tt.button) == null ? void 0 : Ct.buttons) == null ? void 0 : Nt.map((T) => ({
            title: T.title,
            link: T.link,
            newTab: T.open_link_in_new_tab || !1,
            mailto: T.mailto || !1,
            icon: T.icon || null,
            iconId: T.icon_id || null
          }))) || []
        },
        properties: s(e({}, g(t)), {
          type: ((It = (bt = t.config) == null ? void 0 : bt.button) == null ? void 0 : It.type) || "regular",
          theme: ((yt = (Ot = t.config) == null ? void 0 : Ot.button) == null ? void 0 : yt.theme) || "light",
          size: ((wt = (Et = t.config) == null ? void 0 : Et.button) == null ? void 0 : wt.size) || "regular",
          pillShape: !!((At = (kt = t.config) == null ? void 0 : kt.button) != null && At.pill),
          alignment: ((Dt = (Pt = t.config) == null ? void 0 : Pt.button) == null ? void 0 : Dt.alignment) || "left",
          style: ((St = (Lt = t.config) == null ? void 0 : Lt.button) == null ? void 0 : St.style) || "1",
          hasIcons: !!((xt = (vt = t.config) == null ? void 0 : vt.button) != null && xt.has_icons)
        })
      };
    case Ni:
      return y((Ft = (Rt = (Ut = t == null ? void 0 : t.config) == null ? void 0 : Ut.card) == null ? void 0 : Rt.image) == null ? void 0 : Ft.asset_id, (Bt = (Mt = (Ht = t == null ? void 0 : t.config) == null ? void 0 : Ht.card) == null ? void 0 : Mt.image) == null ? void 0 : Bt.url), {
        id: t.id,
        name: "Card",
        type: Br,
        content: {
          heading: vr({
            id: `cardTitle_${t.id}`,
            type: S,
            content: { html: (Wt = (zt = t == null ? void 0 : t.config) == null ? void 0 : zt.card) == null ? void 0 : Wt.headline }
          }),
          text: vr({
            id: `cardContent_${t.id}`,
            type: L,
            content: { html: (Gt = ($t = t == null ? void 0 : t.config) == null ? void 0 : $t.card) == null ? void 0 : Gt.content }
          }),
          image: {
            name: "Image",
            type: I,
            assetUrl: ((Vt = (Yt = (qt = t == null ? void 0 : t.config) == null ? void 0 : qt.card) == null ? void 0 : Yt.image) == null ? void 0 : Vt.url) || "",
            content: {
              assetUrl: ((Xt = (jt = (Qt = t == null ? void 0 : t.config) == null ? void 0 : Qt.card) == null ? void 0 : jt.image) == null ? void 0 : Xt.url) || "",
              assetId: ((Zt = (Jt = (Kt = t == null ? void 0 : t.config) == null ? void 0 : Kt.card) == null ? void 0 : Jt.image) == null ? void 0 : Zt.asset_id) || "",
              altText: ((rr = (tr = (dt = t == null ? void 0 : t.config) == null ? void 0 : dt.card) == null ? void 0 : tr.image) == null ? void 0 : rr.alt_text) || ""
            },
            properties: {
              isDecorative: ((sr = (er = (ir = t == null ? void 0 : t.config) == null ? void 0 : ir.card) == null ? void 0 : er.image) == null ? void 0 : sr.decorative_image) || !1,
              naturalWidth: ((or = (cr = (ar = t == null ? void 0 : t.config) == null ? void 0 : ar.card) == null ? void 0 : cr.image) == null ? void 0 : or.cropped_width) || 0,
              // New
              naturalHeight: ((lr = (nr = (pr = t == null ? void 0 : t.config) == null ? void 0 : pr.card) == null ? void 0 : nr.image) == null ? void 0 : lr.cropped_height) || 0,
              // New
              focalPointPosition: ((ur = (mr = (gr = t == null ? void 0 : t.config) == null ? void 0 : gr.card) == null ? void 0 : mr.image) == null ? void 0 : ur.focalPointPosition) || {
                // New
                x: 50,
                y: 50
              }
            }
          }
        },
        properties: s(e({}, g(t)), {
          design: ((_r = (fr = t == null ? void 0 : t.config) == null ? void 0 : fr.card) == null ? void 0 : _r.design) || "box-shadow",
          showImage: ((Tr = (hr = t == null ? void 0 : t.config) == null ? void 0 : hr.card) == null ? void 0 : Tr.hasImage) || !1,
          showHeadline: ((Nr = (Cr = t == null ? void 0 : t.config) == null ? void 0 : Cr.card) == null ? void 0 : Nr.hasHeadline) || !1,
          imagePosition: (Ir = (br = t == null ? void 0 : t.config) == null ? void 0 : br.card) != null && Ir.imageRight ? "right" : "left",
          wrapText: ((yr = (Or = t == null ? void 0 : t.config) == null ? void 0 : Or.card) == null ? void 0 : yr.wrapText) || !1,
          textCursor: ((wr = (Er = t == null ? void 0 : t.config) == null ? void 0 : Er.card) == null ? void 0 : wr.textCursor) || 0,
          headlineCursor: ((Ar = (kr = t == null ? void 0 : t.config) == null ? void 0 : kr.card) == null ? void 0 : Ar.headlineCursor) || 0
        })
      };
    case Ii:
      return {
        id: t.id,
        name: "Form",
        type: Hr,
        content: {
          formId: ((Pr = t.config.form) == null ? void 0 : Pr.form_id) || null
        },
        properties: s(e({}, g(t)), {
          showOneQuestionAtATime: ((Dr = t.config.form) == null ? void 0 : Dr.show_one_question_at_time) || !1
        })
      };
    case Li:
      return {
        id: t.id,
        name: "Table",
        type: D,
        content: {
          html: vi(t.config.table)
        },
        properties: s(e({}, g(t)), {
          theme: "default",
          alternatingColors: !1
        })
      };
    case Ti:
      return {
        id: t.id,
        name: "Table",
        type: D,
        content: {
          html: t.config.table.content
        },
        properties: s(e({}, g(t)), {
          theme: t.config.table.theme,
          alternatingColors: t.config.table.alternatingColors
        })
      };
    case hi: {
      const T = t.config.accordion.icon_style === "minus" ? "plus" : t.config.accordion.icon_style, o = {
        id: t.id,
        name: "Accordion",
        type: Gr,
        properties: s(e({}, g(t)), {
          theme: t.config.accordion.theme,
          iconStyle: T,
          allowMultipleOpenPanels: t.config.accordion.allow_multiple_open_panels
        }),
        nodes: [
          s(e({}, w({ type: E })), {
            nodes: t.config.accordion.items.map((P) => Ui(P))
          })
        ]
      };
      return o.nodes[0].nodes.map((P) => P.parentAccordionId = o.id), o;
    }
    case Oi:
      return {
        id: t.id,
        name: "List",
        type: Rr,
        content: {
          items: [...t.config.list.items]
        },
        properties: s(e({}, g(t)), {
          design: t.config.list.design,
          format: t.config.list.format
        })
      };
    case yi:
      return {
        id: t.id,
        name: "Navigation",
        type: Ur,
        content: {
          selectedPageId: t.config.selectedPageId,
          selectedChildrenIds: t.config.selectedChildrenIds
        },
        properties: {
          design: t.config.design,
          color: t.config.color
        }
      };
    case O:
      return {
        id: t.id,
        name: "Shared content",
        type: xr,
        sharedContentId: t.config.sharedContentId,
        properties: t.config.properties,
        nodes: [
          e({}, w({ type: E }))
        ]
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, Ui = (t) => ({
  id: t.id,
  name: "Accordion Panel",
  type: $r,
  properties: s(e({}, g(t)), {
    text: t.text,
    panelExpanded: t.panelExpanded
  }),
  nodes: [
    s(e({}, w({ type: E })), {
      nodes: t.content.map((r) => x(r))
    })
  ]
}), y = (t, r) => {
  A = s(e({}, A), {
    [t]: {
      url: r
    }
  });
}, b = (t) => {
  var c, n, l, h, m, u, f, a;
  (l = (n = (c = t.properties) == null ? void 0 : c.backgroundImage) == null ? void 0 : n.image) != null && l.content && y(
    (u = (m = (h = t.properties.backgroundImage) == null ? void 0 : h.image) == null ? void 0 : m.content) == null ? void 0 : u.assetId,
    (a = (f = t.properties.backgroundImage) == null ? void 0 : f.image) == null ? void 0 : a.assetUrl
  );
  const r = e({
    customClasses: [],
    anchorTag: ""
  }, t.properties || xi(t));
  return {
    id: t.id,
    properties: r,
    nodes: Ri(t)
  };
}, g = (t) => {
  var r, c;
  return {
    anchorTag: ((r = t.properties) == null ? void 0 : r.anchorTag) || "",
    customClasses: ((c = t.properties) == null ? void 0 : c.customClasses) || []
  };
}, Ri = (t) => t.config ? t.config.map((c) => {
  const n = c.map((l) => x(l));
  return s(e({}, w({ type: E })), {
    nodes: n
  });
}).flat() : [];
export {
  Bi as convertLegacyPageConfigToPageBuilderConfig,
  Mi as convertPageBuilderConfigToLegacyPageConfig,
  vi as convertTableToV2
};
